// frontend/src/components/Footer.jsx
import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./Footer.css";

function PrivacyModal({ onClose }) {
  return (
    <div className="privacy-modal" role="dialog" aria-modal="true" aria-label="Privacy Policy">
      <button className="privacy-modal__close" onClick={onClose} aria-label="Close">×</button>
      <h2>Privacy Policy</h2>
      <section>
        <p>We respect everyone's personal and confidential information...</p>
      </section>
      <section>
        <h3>Data Collection</h3>
        <ul>
          <li>Data on usage history or pattern on the website.</li>
          <li>Data provided on the website for subscribing to any products or services.</li>
          <li>Data related to transaction details made through the website.</li>
        </ul>
      </section>
      <section>
        <h3>Data Usage</h3>
        <ul>
          <li>To showcase products and services as per browsing history.</li>
          <li>To serve the products and services transacted on the website.</li>
          <li>To send you statements, product notes, or any notifications.</li>
        </ul>
      </section>
    </div>
  );
}

export default function Footer({ projectId, footer }) {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const { phases } = footer;

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="footer__inner">
        <div className="footer__cols">
          {/* Developer */}
          <div className="footer__col">
            <h6 className="footer__label">DEVELOPED BY</h6>
            <img
              src={uploadsUrl(projectId, "developer.webp")}
              alt="Developer"
              className="footer__dev-img"
              loading="lazy"
            />
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h6 className="footer__label">CONTACT US</h6>
            <a href="tel:+918069368300" className="footer__contact-link">+91 8069368300</a>
            <a href="mailto:care@thehomestore.co.in" className="footer__contact-link">
              care@thehomestore.co.in
            </a>
            <h6 className="footer__label footer__label--small">AUTHORIZED CHANNEL PARTNER</h6>
            <img
              src="https://microsite.thehomestore.co.in/uploads/homestore_logo.png"
              alt="The Homestore"
              className="footer__partner-img"
              loading="lazy"
            />
          </div>

          {/* RERA */}
          <div className="footer__col">
            <h6 className="footer__label">RERA NUMBER</h6>
            {phases.map((p, i) => (
              <div key={i} className="footer__rera-item">
                <span>{p.phase}</span>
                {p.rera && <span>{p.rera}</span>}
                <span className="footer__rera-site">rera.wb.gov.in</span>
              </div>
            ))}
            <button className="footer__privacy-link" onClick={() => setShowPrivacy(true)}>
              View Privacy Policy
            </button>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© 2026 The Homestore – All rights reserved</p>
        </div>
      </div>

      {showPrivacy && (
        <>
          <div className="privacy-backdrop" onClick={() => setShowPrivacy(false)} />
          <PrivacyModal onClose={() => setShowPrivacy(false)} />
        </>
      )}
    </footer>
  );
}
